import React from 'react';
import HelpIcon from '../HelpIcon/HelpIcon';
import './HelpIconButton.scss';
import useTranslation from '../../hooks/useTranslation';

interface HelpIconButtonProps {
  helpIconId: string;
}

function HelpIconButton({ helpIconId }: HelpIconButtonProps) {
  const { translateText } = useTranslation();
  return (
    <button
      id={helpIconId}
      type="button"
      title={translateText('Open Help')}
      className="help-icon-button"
    >
      <HelpIcon />
    </button>
  );
}

export default HelpIconButton;
